module.exports = __webpack_public_path__ + "static/img/A-apple.8c398a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/A-apple.png
// module id = VkKt
// module chunks = 3